// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import type { RootState } from 'Store';

// Helper function to wait for files to be populated in the state
// This is used to ensure that the file deletion process waits until the files are available in the state
const waitForFiles = async (
  getState: () => RootState,
  filename: string,
  type: 'tif' | 'zip',
): Promise<IPanoramaFile | ITifFile | undefined> => {
  const maxAttempts = 20;
  const getFiles = () => {
    if (type === 'tif') {
      return getState().project.project.tifFiles;
    }
    return getState().project.project.panoramaFiles;
  };

  let attempt = 0;
  // eslint-disable-next-line no-await-in-loop
  while (attempt < maxAttempts) {
    const files = getFiles();
    const found = files.find((fileRecord) => fileRecord.filename.includes(filename));
    if (found) return found;
    // eslint-disable-next-line no-await-in-loop
    await new Promise((resolve) => { setTimeout(resolve, 500); });
    attempt += 1;
  }
  throw new Error(`Timeout waiting for ${type}Files to be populated`);
};

export default waitForFiles;
